import { createSlice } from "@reduxjs/toolkit";

const initialState = {
 linguist_invoice_list : [],
 linguist_invoice_list_approved : [],
 invoice_list_count : [],
 client_invoice_creation: [],
 client_invoice_list : [],
 client_scoop_invoice_selection:[],
 freelance_invoice_part_payments:[],
 client_invoice_part_payments:[],
 users_list:[],
 email_template:[],
 pdf_downloaded:[],
}


const InvoiceSlice = createSlice({
    name: "InvoiceSlice",
    initialState,
    reducers: {
        setLinguistInvoice: (state, action) => ({
            ...state,
            linguist_invoice_list: action.payload
        }),
        setApprovedLinguistInvoiceList: (state, action) => ({
            ...state,
            linguist_invoice_list_approved: action.payload
        }),
        setClientInvoiceCreation: (state, action) => ({
            ...state,
            client_invoice_creation: action.payload
        }),
        setClientInvoiceListCount: (state, action) => ({
            ...state,
            invoice_list_count: action.payload
        }),
        setClientInvoice: (state, action) => ({
            ...state,
            client_invoice_list: action.payload
        }),
        setClientScoopData: (state, action) => ({
            ...state,
            client_scoop_invoice_selection: action.payload
        }),
        setFreelanceInvoicePartPayments: (state, action) => ({
            ...state,
            freelance_invoice_part_payments: action.payload
        }),
        setClientInvoicePartPayments: (state, action) => ({
            ...state,
            client_invoice_part_payments: action.payload
        }),
        setUsers: (state, action) => ({
            ...state,
            users_list: action.payload
        }),
        setEmailTemplate: (state, action) => ({
            ...state,
            email_template: action.payload
        }),
        setDownloadPdf: (state, action) => ({
            ...state,
            pdf_downloaded: action.payload
        }),
    }
})

export const {setLinguistInvoice,setClientInvoice,setClientInvoiceListCount,setClientInvoiceCreation,setClientScoopData,setFreelanceInvoicePartPayments,setClientInvoicePartPayments,setApprovedLinguistInvoiceList,setUsers,setEmailTemplate,setDownloadPdf} = InvoiceSlice.actions

export default InvoiceSlice.reducer;